import api from './api';

/**
 * Service for interacting with the chatbot API
 */
const chatbotService = {
  /**
   * Create a new chat session
   * @returns {Promise<string>} - The session ID
   */
  createSession: async () => {
    try {
      const response = await api.post('/chatbot/sessions');
      return response.data.sessionId;
    } catch (error) {
      console.error('Error creating chat session:', error);
      throw error;
    }
  },

  /**
   * Send a message to the chatbot
   * @param {string} sessionId - The session ID
   * @param {string} message - The user's message
   * @returns {Promise<object>} - The chatbot's response
   */
  sendMessage: async (sessionId, message) => {
    try {
      const response = await api.post('/chatbot/messages', {
        sessionId,
        message,
      });
      return response.data;
    } catch (error) {
      console.error('Error sending message:', error);
      
      // Fallback to local processing if the API is unavailable
      return {
        text: "I'm having trouble connecting to the server. Please try again later or contact hello@laprecio.com for assistance.",
        timestamp: new Date().toISOString(),
        isError: true,
      };
    }
  },

  /**
   * Get the conversation history for a session
   * @param {string} sessionId - The session ID
   * @returns {Promise<object>} - The conversation history
   */
  getConversation: async (sessionId) => {
    try {
      const response = await api.get(`/chatbot/sessions/${sessionId}`);
      return response.data;
    } catch (error) {
      console.error('Error getting conversation:', error);
      throw error;
    }
  },

  /**
   * Submit feedback for a message
   * @param {string} sessionId - The session ID
   * @param {number} messageIndex - The index of the message
   * @param {boolean} isPositive - Whether the feedback is positive
   * @param {string} feedbackText - Additional feedback text
   * @returns {Promise<object>} - The response
   */
  submitFeedback: async (sessionId, messageIndex, isPositive, feedbackText = '') => {
    try {
      const response = await api.post('/chatbot/feedback', {
        sessionId,
        messageIndex,
        isPositive,
        feedbackText,
      });
      return response.data;
    } catch (error) {
      console.error('Error submitting feedback:', error);
      throw error;
    }
  },
};

export default chatbotService;
